// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-logo-logo-logo-bmjhh{display:inline-block}.components-logo-logo-img-jroty,.components-logo-logo-logo-bmjhh{height:100%}.components-logo-logo-img-jroty{width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "components-logo-logo-logo-bmjhh",
	"img": "components-logo-logo-img-jroty"
};
module.exports = ___CSS_LOADER_EXPORT___;
